  <div class="diagnostics-container">
    <section class="diagnostics-section">
      <div class="modal-overlay" *ngIf="isLoading">
         <p-progressSpinner styleClass="large-spinner"></p-progressSpinner>
      </div>
      <div class="section-header">
        <div class="diagnostic-header">
          <div class="tab active">
            {{ "sharedArchives.pendingFiles" | transloco }}
          </div>
        </div>
      </div>
      <div class="icons-container">
        <span>{{ "sharedArchives.pendingFilesDesc" | transloco }}</span>
        <div class="icons">
          <i class="pi pi-search"></i>
          <i class="pi pi-filter"></i>
        </div>
      </div>
    <div class="diagnostic-grid">
      <div class="diagnostic-item" *ngFor="let notification of notifications">
        <div class="diagnostic-inner">
          <label> {{notification.fileName}} </label>
          <p> {{ "sharedArchives.sharedBy" | transloco }}: {{ notification.userOwnerName.split(' ')[0] }}</p>
          <p> {{ "sharedArchives.fileType" | transloco }}: {{ getTipoArquivo(notification.typeFile) }} </p>
          <p> {{ "sharedArchives.date" | transloco }}: {{ notification.sharedDate | date : "dd/MM/yyyy HH:mm:ss" }} </p>
          <div class="project-tags">
            <span class="tag accept" (click)="acceptOrDeclineArchive(notification.id, true)" ><i class="pi pi-thumbs-up"></i></span>
            <span class="tag decline" (click)="acceptOrDeclineArchive(notification.id, false)" ><i class="pi pi-thumbs-down"></i></span>
          </div>
        </div>
      </div>
    </div>
    </section>
    <div>
      <div class="header-tabs">
        <div class="tab active">
          {{ "sharedArchives.sharedWithMe" | transloco }}
        </div>
      </div>
      <p-table #dtListSharedArchives [value]="listSharedArchives" [rows]="5"
                [loading]="loadingShareArchives" [paginator]="true" [showCurrentPageReport]="true"
                currentPageReportTemplate="{{ 'project.detail.tableShare.currentPage' | transloco }}"
                [globalFilterFields]="['name', 'email', 'date']" [tableStyle]="{ 'min-width': '75rem' }">

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="name" style="width:30%">
                            {{ 'project.detail.tableShare.name' | transloco }} <p-sortIcon field="name" />
                        </th>
                        <th pSortableColumn="email" style="width:35%">
                            {{ 'project.detail.tableShare.email' | transloco }} <p-sortIcon field="email" />
                        </th>
                        <th style="width:15%">{{ 'project.detail.tableShare.action' | transloco }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-sharedArchives let-ri="rowIndex">
                    <tr>
                        <td>
                            {{ sharedArchives.fileName }}
                        </td>
                        <td>
                            {{ getTipoArquivo(sharedArchives.typeFile) }}
                        </td>
                        <td>
                          <p-button [rounded]="true" [text]="true" icon="pi pi-trash" (click)="acceptOrDeclineArchive(sharedArchives.id, false)" />
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5">{{ 'project.detail.tableShare.noFound' | transloco }}.</td>
                    </tr>
                </ng-template>
            </p-table>
    </div>
  </div>
  <p-toast key="toastProject" />
